import { LoanStatusType } from '../loans/LoanStatusType';

export const approvedAmountTypes = [LoanStatusType.Approved, LoanStatusType.Lost, LoanStatusType.Deleted];
